import { Box, Grid, Stack, Typography, useTheme } from "@mui/material";
import Title1 from '../../components/title/title1';
import { useTranslation } from "react-i18next";
import companyData from '../../data/company.json';
import countriesData from '../../data/clients.json';
import Groups3Icon from '@mui/icons-material/Groups3';
import { useCallback, useState } from "react";
import YouTube from 'react-youtube';

const aboutLocales = "about";

const AboutHero = () => {
    const {t} = useTranslation();
    const theme = useTheme();

    const [youtubeVideoError, setYoutubeVideoError] = useState(false);

    const OnYoutubeError = useCallback((event) => {
        // // The event contains a data property with the error code.
        // const errorCode = event.data;

        // // Map the YouTube error code to a readable message
        // let errorMessage = '';
        
        // switch (errorCode) {
        //     case 2:
        //         errorMessage = t(`errors.youtube_video.invalid`);
        //         break;
        //     case 5:
        //         errorMessage = t(`errors.youtube_video.player_error`);
        //         break;
        //     case 100:
        //         errorMessage = t(`errors.youtube_video.not_found`);
        //         break;
        //     case 101:
        //     case 150:
        //         errorMessage = t(`errors.youtube_video.restricted`);
        //         break;
        //     default:
        //         errorMessage = t(`errors.youtube_video.unknown`);
        // }

        setYoutubeVideoError(true);
    }, []);

    const getYoutubeVideoID = useCallback(() => {
        const url = companyData.introductionVideo;

        var regExp = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)[\w\-]{11}(?:[&?][^\s]*)?$/;
        var match = url.match(regExp);

        if (match) {
            const regExp = /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/gm;
            return regExp.exec(url)[3];
        }
        else {
            // setYoutubeVideoError(t(`errors.youtube_video.invalid`));
            setYoutubeVideoError(true);

            return null;
        }
    }, [companyData]);

    return (
        <>
            <Stack
                direction='column'
                alignItems='center'
            >
                <Title1 
                    title={t(`${aboutLocales}.title`)}
                    description={t(`${aboutLocales}.description`)}
                    chipIcon={<Groups3Icon color="white"/>}
                    chipLabel={t(`${aboutLocales}.chipTitle`)}
                    chipColor="#ffa103"
                />

                {/* <Grid
                    direction={{xs: 'column-reverse', md: 'row'}}
                    alignItems='center'
                    container
                    width='100%'
                    spacing={{xs: 2.5, md: 0}}
                >
                    <Grid
                        size={{xs: 12, md: 6}}
                    >
                        <Stack
                            direction='column'
                            alignItems={{xs: 'center', md: 'start'}}
                        >
                            <Typography 
                                sx={{
                                    fontWeight: 800,
                                    fontSize: {xs: 12, md: 16},
                                    textAlign: {xs: 'center', md: "left"},
                                    lineHeight: 1.5,
                                    color: theme.palette.text.primary,
                                    pb: 1
                                }}
                            >
                                {t(`${aboutLocales}.stats.title`)}
                            </Typography>

                            <Grid
                                direction='row'
                                justifyContent={{xs: 'end', md: 'start'}}
                                width='100%'
                                xs
                                container
                                spacing={{xs: 5, md: 0}}
                            >
                                <Grid 
                                    size={{xs: 6, md: 4}}
                                    display='flex'
                                    justifyContent={{xs: 'end', md: 'start'}}
                                >
                                    <AboutStats 
                                        value={`${new Date().getFullYear() - companyData.stats.founded}+`} 
                                        description={t(`${aboutLocales}.stats.years`)}
                                        column={1}
                                    />
                                </Grid>

                                <Grid size={{xs: 6, md: 4}}>
                                    <AboutStats 
                                        value={`${countriesData.length}+`} 
                                        description={t(`${aboutLocales}.stats.country`)}
                                        column={2}
                                    />
                                </Grid>
                            </Grid>

                            <Stack
                                direction='row'
                                justifyContent={{xs: 'start', md: 'start'}}
                                width='100%'
                                xs
                                container
                                spacing={{xs: 5, md: 0}}
                            >
                                <Grid 
                                    size={{xs: 6, md: 4}}
                                    display='flex'
                                    justifyContent={{xs: 'end', md: 'start'}}
                                >
                                    <AboutStats 
                                        value={`${companyData.stats.clients}+`} 
                                        description={t(`${aboutLocales}.stats.clients`)}
                                        column={1}
                                    />
                                </Grid>

                                <Grid size={{xs: 6, md: 4}}>
                                    <AboutStats 
                                        value={`${companyData.stats.digitalSolutions}+`} 
                                        description={t(`${aboutLocales}.stats.digitalSolutions`)}
                                        column={2}
                                    />
                                </Grid>
                            </Stack>
                        </Stack>
                    </Grid>

                    <Grid
                        size={{xs: 12, md: 6}}
                    >
                        <Box width='100%'>
                            {
                                youtubeVideoError
                                ?
                                <Stack
                                    direction='row'
                                    justifyContent='center'
                                    alignItems='center'
                                    sx={{
                                        width: '100%',
                                        height: window.innerWidth < 600 ? 200 : 300,
                                        backgroundColor: theme.palette.background.paper
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: 600,
                                            fontSize: 12,
                                            textAlign: 'center'
                                        }}
                                    >
                                        Unable to load the video
                                    </Typography>        
                                </Stack>
                                :
                                <Box width='100%' sx={{backgroundColor: 'black'}}>
                                    <YouTube 
                                        videoId={getYoutubeVideoID()}
                                        opts={{
                                            width: '100%',
                                            height: window.innerWidth < 600 ? 200 : 300,
                                            playerVars: {
                                                // https://developers.google.com/youtube/player_parameters
                                                autoplay: 0,
                                                color: 'white'
                                            }
                                        }}
                                        onError={OnYoutubeError}
                                        onReady={() => setYoutubeVideoError(false)}
                                    />
                                </Box>
                            }
                        </Box>
                    </Grid>
                </Grid> */}
            </Stack>
        </>
    );
}

export default AboutHero;

const AboutStats = ({
    value,
    description,
    column
}) => {
    const theme = useTheme();

    return (
        <>
            <Stack
                direction='column'
            >
                <Typography 
                    sx={{
                        fontWeight: 800,
                        fontSize: {xs: 42, md: 64},
                        textAlign: {xs: column === 1 ? 'right' : 'left', md: 'left'},
                        lineHeight: 1.5,
                        color: theme.palette.primary.main
                    }}
                >
                    {value}
                </Typography>

                <Typography 
                    sx={{
                        fontWeight: 400,
                        fontSize: {xs: 12, md: 14},
                        textAlign: {xs: column === 1 ? 'right' : 'left', md: 'left'},
                        lineHeight: 1.5,
                        color: theme.palette.text.secondary,
                        mt: {xs: -1, md: -2}
                    }}
                >
                    {description}
                </Typography>
            </Stack>
        </>
    );
}